'use client';

import { __assign, __spreadArray } from '../../_virtual/_tslib.js';
import { createContext } from 'react';
import { initialTreeSelect } from './index.js';
import { TreeSelectAction } from './types.js';

var treeSelectReducer = function (state, action) {
    var type = action.type, payload = action.payload;
    switch (type) {
        case TreeSelectAction.UPDATE_SELECTED_PARENT_ID: {
            var parentId = payload;
            return __assign(__assign({}, state), { selectedParentId: parentId });
        }
        case TreeSelectAction.UPDATE_SELECT_LEVEL: {
            var levelIndex = payload;
            return __assign(__assign({}, state), { selectLevel: levelIndex });
        }
        case TreeSelectAction.UPDATE_HISTORY: {
            var _a = payload, _b = _a.selectedParentId, selectedParentId = _b === void 0 ? -1 : _b, _c = _a.selectLevel, selectLevel = _c === void 0 ? 0 : _c;
            return __assign(__assign({}, state), { history: __assign(__assign({}, state.history), { selectedParentId: selectedParentId, selectLevel: selectLevel }) });
        }
        case TreeSelectAction.UPDATE_SCROLLING_POSITION: {
            var history_1 = __assign({}, state.history);
            var updateItemPosition = payload;
            // This only work for 2 levels categories.
            // If we using 3 levels (currently not supported in TreeSelect) then this need to rework.
            var bodyScrollPosition = [updateItemPosition];
            return __assign(__assign({}, state), { history: __assign(__assign({}, history_1), { bodyScrollPosition: __spreadArray([], bodyScrollPosition, true) }) });
        }
        default:
            console.error('Unknown type of Reducer');
            return __assign({}, state);
    }
};
var TreeSelectContext = createContext({
    state: initialTreeSelect,
    dispatch: function () { }
});

export { TreeSelectContext, treeSelectReducer };
//# sourceMappingURL=reducer.js.map
